module.exports = __webpack_public_path__ + "static/media/ser_per_to_wor.5133c944.png";